import * as React from "react";
import { useState } from "react";
import { State } from "@progress/kendo-data-query";
import { IconButton, TextField } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { StandardTextFieldProps } from "@mui/material/TextField/TextField";
import { buildRelationFilter, relationMatcherProps } from "./BuildRelationFilter";
import { removeFieldsFromCurrentFilter } from "../../Layout/Filter/RemoveFieldsFromCurrentFilter";
import { addFilterToCurrentDataState } from "../../Layout/Filter/ApplyFilter";

type MdmRelationQuickFilterProps = {
  currentDataState: State;
  findText: string;
  relationMatchers: relationMatcherProps;
  triggerFiltering: (dataStateWithNewFilters: State) => void;
};

export default function MdmRelationQuickFilter({
  currentDataState,
  findText,
  relationMatchers,
  triggerFiltering,
  ...props
}: MdmRelationQuickFilterProps & StandardTextFieldProps) {
  const [inputValue, setInputValue] = useState("");
  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === "Enter") {
      combineDataStateWithInputValue();
      event.stopPropagation();
    }
  };

  const handleInputChanged = (event: React.ChangeEvent<HTMLInputElement>) => {
    setInputValue(event.target.value);
  };

  const combineDataStateWithInputValue = () => {
    const filterFields = relationMatchers.map((matcher) => matcher.relation);
    removeFieldsFromCurrentFilter(filterFields, currentDataState);

    if (currentDataState.filter?.filters.length === 0) {
      const noFilterDataState: State = {
        ...currentDataState,
        filter: undefined,
      };

      return noFilterDataState;
    }

    const filter = buildRelationFilter(relationMatchers, inputValue);
    return addFilterToCurrentDataState(filter, currentDataState);
  };

  return (
    <TextField
      {...props}
      onChange={handleInputChanged}
      onKeyDown={handleKeyDown}
      value={inputValue}
      placeholder={findText}
      size="small"
      InputProps={{
        endAdornment: (
          <IconButton edge="end" onClick={() => triggerFiltering(combineDataStateWithInputValue())}>
            <SearchIcon />
          </IconButton>
        ),
      }}
      sx={{ width: "200px", padding: "0.3rem", paddingBottom: "16px" }}
    />
  );
}
